export class CallCenterTopProduto {
  constructor(
    public produto: string,
    public valor_atual: number,
    public valor_anterior: number,
    public variacao_valor_percentual: number,
    public litros_atual: number,
    public litros_anterior: number,
    public variacao_litros_percentual: number
  ) { }
}
